// Practice sentences grouped by difficulty.
// Difficulty maps to tree depth: only letters at or above that depth are used,
// so learners can master the top of the tree before expanding the alphabet.
//
// Depth 1: E, T
// Depth 2: + I, A, N, M
// Depth 3: + S, U, R, W, D, K, G, O
// Depth 4: + full alphabet (Q Z Y C X B J P L F V H)
// Expert : + digits 0-9

// EASY — only {A, E, I, M, N, T}
const EASY = [
  "I AM NATE",
  "MEET ME AT AN INN",
  "TEN MEN IN A TENT",
  "A MAN ATE A MINT",
  "TIM MET NAN",
  "AN ANT IN A TIN",
  "MAMA ATE A MINT",
  "I MEAN IT",
  "NINE MEN MET",
  "MEET EMMA AT NINE",
  "I MET ANNE AT AN INN",
  "TINA MET EMMA",
  "AIM AT AN ANT",
  "A TINY MITTEN", // TINY has Y? yes — Y is depth 4, drop. Replacing:
  "A MITTEN IN A TIN",
  "NATE MET TIM AT AN INN",
  "EMMA AND TINA MEAN IT", // 'D' is depth 3 — drop. Replacing:
  "EMMA ATE A TEA",
  "TEN ANTS ATE A MINT", // 'S' is depth 3 — drop
  "AN INNATE NAME",
];

// MEDIUM — {A,E,I,M,N,T,S,U,R,W,D,K,G,O}
const MEDIUM = [
  "A DOG RAN AT DAWN",
  "WE MET A WISE MAN",
  "SEND A NOTE TO SAM",
  "A KIND WORD TO A MAN",
  "WARM OATS AT DAWN",
  "WE SAW A GREAT STORM",
  "READ A GREAT STORY",
  "SEND ME A MESSAGE",
  "I SAW A MOUSE IN A ROOM",
  "ONE WARM SUMMER DAY",
  "WE WORK AT SUNRISE",
  "WRITE A KIND NOTE",
  "A MAN RODE A TRAIN",
  "I AM WARM AND DRY",
  "RAIN OR SUNSET",
  "GOOD MORNING SIR",
  "A DOG AND A RAT",
  "ONE GOOD TURN",
  "I AM ON A TRAIN",
  "MEET ME IN A MOMENT",
  "TINA DREW A DOG",
  "ROSES AND DAISIES",
  "A DUSTY ROOM",
  "I SAW SAM AT WORK",
  "SEND A MAN TO MARS",
];

// HARD — full alphabet (pangrams + common sentences)
const HARD = [
  "THE QUICK BROWN FOX JUMPS OVER A LAZY DOG",
  "PACK MY BOX WITH FIVE DOZEN LIQUOR JUGS",
  "SPHINX OF BLACK QUARTZ JUDGE MY VOW",
  "HOW VEXINGLY QUICK DAFT ZEBRAS JUMP",
  "WALTZ BAD NYMPH FOR QUICK JIGS VEX",
  "JACKDAWS LOVE MY BIG SPHINX OF QUARTZ",
  "THE FIVE BOXING WIZARDS JUMP QUICKLY",
  "BRIGHT VIXENS JUMP DOZY FOWL QUACK",
  "A JOURNEY OF A THOUSAND MILES",
  "SEND ME A POSTCARD FROM PARIS",
  "BUY MILK AND BREAD AT THE STORE",
  "THE LAZY CAT SLEPT BY THE WINDOW",
  "MAY THE FORCE BE WITH YOU",
  "PLAY A SONG ON THE PIANO",
  "THE EARLY BIRD CATCHES THE WORM",
  "FORTUNE FAVORS THE BOLD",
  "A PICTURE IS WORTH A THOUSAND WORDS",
  "A QUICK BROWN FOX JUMPED OVER A FENCE",
  "DELIVER THE PACKAGE BY MIDNIGHT",
  "KEEP CALM AND CARRY ON",
  "THE BOOK IS ON THE TABLE",
  "FIVE QUICK ZEBRAS VEX HIS JUDGE",
  "CATCH THE TRAIN AT PLATFORM 9",
  "CALL ME AT 555 1234",
  "MEET AT 7 PM SHARP",
  "THE YEAR 1969 SAW THE MOON LANDING",
  "ROOM 204 IS ON THE SECOND FLOOR",
  "TURN LEFT AT HIGHWAY 101",
];

// Remove the commented placeholders that snuck in
const cleaned = (arr) =>
  arr.filter((s) => !/(TINY|EMMA AND TINA MEAN|TEN ANTS)/i.test(s));

export const PRACTICE_SETS = {
  0: cleaned(EASY),
  1: cleaned(MEDIUM),
  2: cleaned(HARD),
};

export const DIFFICULTY_LABELS = ["EASY", "MEDIUM", "HARD", "CUSTOM"];
export const CUSTOM_DIFFICULTY = 3;

export function randomSentence(difficulty, exclude = "") {
  const pool = PRACTICE_SETS[difficulty] || PRACTICE_SETS[1];
  let pick = pool[Math.floor(Math.random() * pool.length)];
  if (pool.length > 1 && pick === exclude) {
    pick = pool[(pool.indexOf(pick) + 1) % pool.length];
  }
  return pick;
}
